import { Box, Chip, Metadata, useTranslation, useTranslations } from "@bsm/component";
import { THoliday } from "@bsm/graphql";
import moment from "moment";
import { Link } from "react-router-dom";
import { useUrlParamsValue } from "@bsm/component";

export const PubilcHolidayListItem = (props: Partial<THoliday>) => {
    const [DATE] = useTranslations(i18n);
    const urlParams = useUrlParamsValue();
    const t = useTranslation();

    return (
        <Box className="mb-4 p-4 w-full">
            <div className="flex w-full justify-between items-start">
                <Link to={`${props.id}?${urlParams}`}>
                    <div className="">
                        <div className="flex items-center gap-2 mb-2">
                            <h4 className="font-semibold text-lg">{props?.value ? t(`Generic.de.${props.value}`) : props?.name}</h4>
                            <Chip label={props.year} className="bg-default" />
                        </div>
                        <Metadata
                            label={DATE}
                            value={moment(props.startDate).format('DD MMM YYYY')}
                        />
                    </div>
                </Link>
            </div>
        </Box>
    );
};

const i18n = [
    "std_date",
];